// Configurazione dei componenti Geist
import { Themes } from '@geist-ui/core';

// Definizione del tema personalizzato Geist per il progetto
export const materiaTheme = Themes.createFromLight({
  type: 'materiaArchive',
  // Personalizza il tema con font personalizzato
  font: {
    sans: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
  }
});

// Mappa delle categorie a colori Geist per i Tag
// Utilizzare solo tipi supportati: success, warning, error, secondary, lite
export const categoryToGeistColor = {
  "Metals": "secondary",
  "Polymers": "secondary",
  "Ceramics": "warning", 
  "Wood": "warning",
  "Fabrics": "error",
  "Composites": "success",
  "Stone": "secondary",
  "Organics": "success",
  "Misc.": "lite"
};

// Mappa per i tag estetici, tattili e tecnici
export const tagTypeToGeistColor = {
  "aesthetic": "error",
  "tactile": "secondary", 
  "technical": "warning"
}; 